import { useEffect, useState } from "react";
import { FormGroup, Label } from "reactstrap";
import { Col } from "reactstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const PhoneNumberField = ({
  input,
  label,
  meta: { touched, error, warning },
  disabled,
  textBlur,
  isRequired,
  placeholder,
  clearField,
}: any) => {
  const [value, setValue] = useState(input.value);

  useEffect(() => {
    setValue(input.value || "+1");
  }, [input.value]);

  useEffect(() => {
    if (clearField) {
      setValue("");
    }
  }, [clearField, input]);

  return (
    <FormGroup row className="mb-3">
      <Label>
        {label}
        {isRequired && <span className="input-required"> *</span>}
      </Label>
      <Col sm={12} className="mr-2">
        <PhoneInput
          country={"us"}
          onlyCountries={["us"]}
          countryCodeEditable={false}
          disabled={disabled}
          onChange={(event: any) => input.onChange(event)}
          onBlur={(event: any) => {
            // input.onBlur(event);
            // input.onChange(event.target.value);
            if (textBlur) {
              textBlur(event);
            }
          }}
          placeholder={placeholder}
          value={value}
        />
        <h6 className="danger">
          {error && <span>{error}</span>}
          {warning && <span>{warning}</span>}
        </h6>
      </Col>
    </FormGroup>
  );
};

export default PhoneNumberField;
